import get from 'lodash/get';
import type { ErrorLike } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { ProjectPlanDocument } from 'graphql/generated/graphql';

const useProjectPlan = (projectId: string) => {
  const { data, loading, error } = useQuery(ProjectPlanDocument, { variables: { projectId } });
  const projectPlan = get(data, 'projectPlan', null);
  const project = get(data, 'project', null);

  const plan = { projectPlan, project };
  return [plan, loading, error] satisfies [typeof plan, boolean, ErrorLike | undefined];
};

export default useProjectPlan;
